import {
  Appliance,
  BatteryReserve,
  EnergyModesResponse,
  SenseSwitch,
  SwitchSchedule,
} from 'clipsal-cortex-types/src/api';

import appliances from '../stubs/appliances.json';
import batteryReserve from '../stubs/battery-reserve.json';
import energyMode from '../stubs/energy_mode.json';
import switches from '../stubs/switches.json';

export const DEVICES_ROUTE_MAP = {
  '/v1/site_devices/2/battery_reserve': batteryReserve as BatteryReserve,
  '/v1/sites/1/appliances': appliances as Appliance[],
  '/v1/sites/1/energy_mode': energyMode as EnergyModesResponse,
  '/v1/sense/sites/1/switches': switches as SenseSwitch[],
  '/v1/switches/1/schedules': [] as SwitchSchedule[],
  '/v1/switches/2/schedules': [] as SwitchSchedule[],
};
